import React from "react";
import Timer from "react-compound-timer";
import UserTimer from "./UserTimer";

const TimerHOC = ({ liveCaseDocumentId, displayTimer, setMessageBar, caseId, onTimerPause }) => {
  return (
    <Timer initialTime={0} startImmediately={true}>
      {({ start, stop, reset, getTimerState, getTime, setTime }) => (
        <UserTimer
          start={start}
          stop={stop}
          reset={reset}
          getTime={getTime}
          getTimerState={getTimerState}
          setTime={setTime}
          liveCaseDocumentId={liveCaseDocumentId}
          displayTimer={displayTimer}
          setMessageBar={setMessageBar}
          caseId={caseId}
          onTimerPause={onTimerPause}
        />
      )}
    </Timer>
  );
};

export default TimerHOC;
